const Info = ({ title = null, children, datas = null }) => (
    <div className="flex justify-between">
        <span className="font-medium text-black dark:text-white">{title}</span>
        <p className="flex justify-between text-black dark:text-white">{children}</p>
        {datas ? <div>{datas}</div> : null}
    </div>
)
export default Info
